import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { channels } from "@/mocks/home";

export default function ChannelSection() {
  return (
    <section id="channels" className="w-full bg-background-100">
      <div className="mx-auto max-w-shell px-4 py-16 md:px-6 md:py-24">
        <Reveal>
          <SectionHeading
            eyebrow="BLACK-TALK CHANNELS"
            title="黑料频道 · 按更新节奏订阅"
            desc="有的频道追得快，有的频道写得深。挑一个符合你阅读习惯的黑料频道，更新自然会出现在你面前。"
            actionText="订阅频道更新"
            actionHref="#download"
          />
        </Reveal>

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2 md:gap-5">
          {channels.map((channel, index) => (
            <Reveal key={channel.name} delay={index * 50}>
              <a
                href="#channels"
                className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 px-5 py-5 transition-colors duration-300 hover:border-secondary-300 cursor-pointer"
              >
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-900 transition-colors duration-300 group-hover:bg-primary-100 group-hover:text-primary-700">
                  <i className={`${channel.icon} text-xl`} />
                </span>

                <span className="min-w-0 flex-1">
                  <span className="flex items-center gap-2">
                    <span className="font-heading text-base font-bold text-foreground-950">
                      {channel.name}
                    </span>
                    <span className="rounded-md bg-accent-100 px-2 py-0.5 text-[11px] font-label text-accent-900">
                      {channel.tag}
                    </span>
                  </span>
                  <span className="mt-1 block truncate text-xs text-foreground-600 md:text-sm">
                    {channel.desc}
                  </span>
                </span>

                <span className="flex shrink-0 flex-col items-end gap-1">
                  <span className="text-xs font-label text-foreground-500">{channel.count}</span>
                  <span className="flex h-8 w-8 items-center justify-center rounded-md border border-background-200 text-foreground-500 transition-colors duration-300 group-hover:border-primary-300 group-hover:text-primary-700">
                    <i className="ri-add-line text-base" />
                  </span>
                </span>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}